"use client";

import { cn } from "@/lib/utils";

export type InlineBadgeVariant = "summary" | "json";

interface InlineBadgeClassNameOptions {
  variant?: InlineBadgeVariant;
  interactive?: boolean;
  className?: string;
}

export function getInlineBadgeClassName({
  variant = "summary",
  interactive = false,
  className,
}: InlineBadgeClassNameOptions = {}) {
  return cn(
    "inline-flex h-6 min-w-0 max-w-full items-center gap-1 rounded-ds-xs px-1.5 align-middle text-xs leading-none",
    variant === "summary" && "bg-blue-100 text-blue-700 dark:bg-blue-950/40 dark:text-blue-300",
    variant === "json" &&
      "bg-ds-surface-card text-ds-text-secondary shadow-ds-soft ring-1 ring-black/5 dark:ring-white/10",
    interactive &&
      variant === "summary" &&
      "cursor-pointer transition-colors hover:bg-blue-200 dark:hover:bg-blue-950/60",
    interactive &&
      variant === "json" &&
      "cursor-pointer transition-colors hover:bg-ds-surface-hover dark:hover:bg-zinc-950",
    className,
  );
}
